import type {ReactNode} from "react";

export type MessageType = Error | ReactNode | string;

export default class DetailedMessage {

    public constructor(public message: MessageType, public messageEnum: MessageEnum = MessageEnum.SUCCESS) {

}
}

export class MessageEnum {

    public color: string = 'success';
    public fa: string = 'info-circle';

    private constructor(color: string, fa: string) {
        this.color = color;
        this.fa = fa;
    }

    public static SUCCESS = new MessageEnum('success', 'check-circle');
    public static INFO = new MessageEnum('info', 'info-circle');
    public static WARNING = new MessageEnum('warning', 'exclamation-circle');
    public static ERROR = new MessageEnum('danger', 'exclamation-circle');
}